// Owner-only actions — managers and viewers cannot do these
const OWNER_ONLY = [
  'delete_property', 'delete_tenant', 'delete_payment',
  'billing', 'settings', 'team', 'plan', 'upgrade'
];

// Viewer-blocked actions — viewers can only read
const VIEWER_BLOCKED = [
  'add_property', 'edit_property',
  'add_tenant', 'edit_tenant',
  'collect_payment', 'approve_payment', 'reject_payment',
  'create_maintenance', 'assign_sp', 'resolve_maintenance',
  'send_message', 'edit_common_charges'
];

export const can = (orgRole, action) => {
  if (!orgRole || orgRole === 'owner') return true;
  if (orgRole === 'viewer') return !VIEWER_BLOCKED.includes(action) && !OWNER_ONLY.includes(action);
  if (orgRole === 'manager') return !OWNER_ONLY.includes(action);
  return false;
};
